import Swiper, { Navigation, Pagination, A11y } from 'swiper';

export default () => {
    const gridAwards = document.querySelector(
        '#awards-wrap .swiper-wrapper'
    );
    const gridAwardsTotal = gridAwards.dataset.totalResults;

    // awards slider
    const awardsSwiper = new Swiper('.awards-wrap', {
        modules: [Navigation, Pagination, A11y],
        navigation: {
            nextEl: '#awards-part .arrow-next__awards',
            prevEl: '#awards-part .arrow-prev__awards',
        },
        a11y: true,
        keyboardControl: true,
        grabCursor: true,
        watchOverflow: true,
        loop: true,
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 5,
            },
            480: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 5,
            },
            1200: {
                slidesPerView: 5,
                spaceBetween: 5,
            },
            1440: {
                slidesPerView: 7,
                spaceBetween: 5,
                loop: gridAwardsTotal > 7,
            },
        },
    });
};